import SpeakerModal from './SpeakerModal';
import Speaker from './Speaker';

export { SpeakerModal };

export default Speaker;
